<template>
  <v-row
    no-gutters
    class="record py-1"
    :class="[record.isRunning() ? 'secondary--text' : 'secondary--text text--lighten-4']"
  >
    <!-- type -->
    <v-col class="d-flex flex-grow-0 justify-center align-center ml-2 mr-3">
      <i 
        aria-hidden="true" 
        class="v-icon notranslate mdi theme--light" 
        :class="getEntryStyle(record.entry.type).icon + ' text--' + getEntryStyle(record.entry.type, { lighten: (record.isRunning() ? 1 : 3) }).color + '--text'"
      />
      <!-- <v-icon :color="getEntryStyle(record.entry.type, { lighten: (record.isRunning() ? 1 : 3) }).color">
      </v-icon> -->
    </v-col>
    <!-- label -->
    <v-col
      :cols="showDetails ? 4 : 5"
      class="d-flex justify-left align-center flex-wrap"
    >
      <v-edit-dialog
        v-if="record.isEditable('label')"
        @open="setEdited({record: record, field: 'label'})"
        @save="onLabelSave()"
        @close="onLabelSave()"
        @cancel="resetEdited()"
      >
        <span class="text-body-2 font-weight-bold">
          {{ record.entry.label }}
        </span>
        <template v-slot:input>
          <v-subheader class="pl-0">
            Label
          </v-subheader>
          <v-text-field
            :value="edited.value"
            :rules="fieldRules.label"
            required
            label="Record label"
            single-line
            @change="setEditedValue"
          />
        </template>
      </v-edit-dialog>
      <span
        v-else
        class="text-body-2"
      >{{ record.entry.label }}</span>
    </v-col>

    <!-- joker cat1 -->
    <v-col
      v-if="showDetails"
      v-show="record.isJoker()"
      cols="1"
      class="d-flex align-center justify-center text-center mx-2"
    >
      <v-edit-dialog
        @open="setEdited({record: record, field: 'cat1'})"
        @save="saveEdited()"
        @close="saveEdited()"
        @cancel="resetEdited()"
      >
        <span class="text-caption font-weight-bold">
          {{ record.entry.cats[0] || 'cat1' }}
        </span>
        <template v-slot:input>
          <v-subheader class="pl-0">
            Cat1
          </v-subheader>
          <v-select
            :items="catalogValues.cat1"
            :value="edited.value"
            label="Cat1"
            single-line
            @change="setEditedValue"
          />
        </template>
      </v-edit-dialog>
    </v-col>

    <!-- joker cat2 -->
    <v-col
      v-if="showDetails"
      v-show="record.isJoker()"
      cols="1"
      class="d-flex align-center justify-center text-center mx-2"
    >
      <v-edit-dialog
        @open="setEdited({record: record, field: 'cat2'})"
        @save="saveEdited()"
        @close="saveEdited()"
        @cancel="resetEdited()"
      >
        <span class="text-caption font-weight-bold">
          {{ record.entry.cats[1] || 'cat2' }}
        </span>
        <template v-slot:input>
          <v-subheader class="pl-0">
            Cat2
          </v-subheader>
          <v-select
            :items="catalogValues.cat2"
            :value="edited.value"
            label="Cat2"
            single-line
            @change="setEditedValue"
          />
        </template>
      </v-edit-dialog>
    </v-col>

    <!-- joker cat3 -->
    <v-col
      v-if="showDetails"
      v-show="record.isJoker()"
      cols="1"
      class="d-flex align-center justify-center text-center mx-2"
    >
      <v-edit-dialog
        @open="setEdited({record: record, field: 'cat3'})"
        @save="saveEdited()"
        @close="saveEdited()"
        @cancel="resetEdited()"
      >
        <span class="text-caption font-weight-bold">
          {{ record.entry.cats[2] || 'cat3' }}
        </span>
        <template v-slot:input>
          <v-subheader class="pl-0">
            Cat3
          </v-subheader>
          <v-select
            :items="catalogValues.cat3"
            :value="edited.value"
            label="Cat3"
            single-line
            @change="setEditedValue"
          />
        </template>
      </v-edit-dialog>
    </v-col>

    <!-- code or joker -->
    <v-col
      v-if="showDetails"
      cols="1"
      class="d-flex align-center justify-center text-center mx-2"
      style="min-width: 90px"
    >
      <span class="text-body-2 font-weight-bold text-wrap">
        <v-edit-dialog
          @open="setEdited({record: record, field: 'code'})"
          @save="saveEdited()"
          @close="saveEdited()"
          @cancel="resetEdited()"
        >
          {{ record.entry.code || 'code' }}
          <template v-slot:input>
            <v-subheader class="pl-0">
              Code
            </v-subheader>
            <v-text-field
              :value="edited.value"
              :rules="fieldRules.code"
              required
              label="Code joker / correction"
              single-line
              @change="setEditedValue"
            />
          </template>
        </v-edit-dialog>
      </span>
    </v-col>

    <!-- qty -->
    <v-col
      class="text-center mx-2 d-flex align-center flex-grow-0 pl-2 pr-4"
      style="min-width: 60px"
    >
      <v-edit-dialog
        v-if="record.isEditable('qty')"
        @open="setEdited({record: record, field: 'qty'})"
        @save="saveEdited()"
        @close="saveEdited()"
        @cancel="resetEdited()"
      >
        <span class="text-caption text-no-wrap">qty: {{ record.qty }}</span>
        <template v-slot:input>
          <v-subheader class="pl-0">
            Quantity
          </v-subheader>
          <v-text-field
            v-model="edited.value"
            :rules="fieldRules.qte"
            required
            type="number"
            :min="0"
            label="Quantity"
            single-line
          />
        </template>
      </v-edit-dialog>
    </v-col>
    <!-- progress & time -->
    <v-col class="d-flex align-center">
      <v-container
        fluid
        class="pa-0"
      >
        <v-row
          no-gutters
          class="flex-grow-0"
        >
          <!-- begin time -->
          <v-col class="justify-start text-wrap text-left text-caption">
            <span v-if="record.type !== 'event'">
              [ {{ record.time.begin.short }}
            </span>
          </v-col>
          <!-- duration -->
          <v-col class="justify-center text-no-wrap text-center">
            <refreshable
              v-if="record.type === 'task' && record.isRunning()"
              :lambda="() => '+ ' + record.getPrettyDuration()"
              :interval="1000"
              :class="[record.isRunning() ? 'text-body-2 font-weight-bold': 'text-caption']"
            />
            <span
              v-else-if="record.type !== 'event'"
              :class="[record.isRunning() ? 'text-body-2 font-weight-bold': 'text-caption']"
            >+ {{ record.getPrettyDuration() }}</span>
          </v-col>
          <!-- end time -->
          <v-col class="justify-end text-no-wrap text-right text-caption">
            <div v-if="record.time.end">
              {{ record.time.end.short }} ]
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-progress-linear
            :indeterminate="record.isRunning()"
            stream
            :color="getEntryStyle(record.entry.type).color"
            :height="record.isRunning() ? 8 : 2"
            :buffer-value="record.isRunning() && !record.autostop ? 0 : 100"
          />
        </v-row>
      </v-container>
    </v-col>

    <!-- autostop -->
    <v-col
      class="d-flex flex-grow-0 justify-center align-center ml-2 mr-4"
      style="min-width: 56px"
    > 
      <v-btn
        v-if="record.isAutoStoppable() && record.isRunning() && record.autostop"
        icon
        @click="record.disableAutoStop()"
      >
        <v-icon
          :color="getAutoStopStyle(record).color"
          :size="getAutoStopStyle(record).size"
          :class="getAutoStopStyle(record).cls"
        >
          {{ getAutoStopStyle(record).icon }}
        </v-icon>
      </v-btn>
      <v-icon
        v-else-if="record.isAutoStoppable()"
        :color="getAutoStopStyle(record).color"
        :size="getAutoStopStyle(record).size"
        :class="getAutoStopStyle(record).cls"
      >
        {{ getAutoStopStyle(record).icon }}
      </v-icon>
    </v-col>

    <!-- actions -->
    <v-col class="d-flex flex-grow-0 align-center">
      <div
        class="d-flex align-center justify-end flex-nowrap"
        style="min-width: 108px"
      >
        <!-- stop button -->
        <button 
          v-if="record.isRunning()"
          type="button"
          class="v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default error--text"
          @click="record.stop()"
        >
          <span class="v-btn__content">
            <i 
              aria-hidden="true" 
              class="v-icon notranslate mdi mdi-stop theme--light"
            />
          </span>
        </button>

        <span 
          v-else 
          class="action"
        >
          &nbsp;
        </span>

        <!-- comment button -->
        <button 
          type="button" 
          class="v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--default" 
          :class="record.comment ? 'cyan--text text--lighten-4' : 'grey--text text--lighten-2'" 
          @click.stop="setEdited({record, field: 'comment'})"
        >
          <span class="v-btn__content">
            <i 
              aria-hidden="true" 
              class="v-icon notranslate mdi theme--light" 
              :class="record.comment ? 'mdi-comment' : 'mdi-comment-outline'"
            />
          </span>
        </button>

        <!-- delete button -->
        <button 
          type="button" 
          class="ml-4 v-btn v-btn--flat v-btn--icon v-btn--round theme--light v-size--x-small grey--text text--lighten-1"
          @click="removeRecord(record)"
        >
          <span class="v-btn__content">
            <i 
              aria-hidden="true" 
              class="v-icon notranslate mdi mdi-close theme--light"
            />
          </span>
        </button>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { Record } from '@/models/journal'

import Refreshable from '@/components/refreshable'
import { getEntryStyle } from '@/components/utils'
import fieldRules from '@/utils/rules'

export default {
	name: 'Record',
	components: {
		Refreshable,
	},
	props: {
		record: {
			type: Record,
			required: true,
		},
		catalogValues: {
			type: Object,
			default: () => ({
				cat1: [],
				cat2: [],
				cat3: [],
				type: [],
			}),
		},
		showDetails: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		// validation rules
		fieldRules,
	}),
	computed: {
		...mapState('journal', {
			edited: state => state.edited,
		}),
	},
	methods: {
		...mapActions('journal', [
			'removeRecord',
			'setEdited',
			'setEditedValue',
			'resetEdited',
			'saveEdited',
		]),
		getEntryStyle,
		onLabelSave() {
			const oldLabel = this.record.entry.label

			this.saveEdited()

			if (oldLabel !== this.record.entry.label) {
				this.$emit('label:changed', this.record)
			}
		},
		getAutoStopStyle(record) {
			var res = {
				icon:
					record.autostop === true
						? 'mdi-arrow-collapse-right'
						: 'mdi-arrow-right',
				color: 'grey lighten-2',
				size: record.autostop === true ? 'large' : 'x-large',
				// cls: 'font-weight-light',
			}

			if (record.isRunning()) {
				res.color = getEntryStyle(record.entry.type, {
					lighten: record.autostop ? 2 : 0,
				}).color

				res.cls =
					record.autostop === true ? 'font-weight-regular' : 'font-weight-bold'
			}
			return res
		},
	},
}
</script>

<style lang="scss">
.qty-slider {
	.v-input__slot {
		margin-bottom: 16px !important; // remove y scrollbar
	}
}
</style>
